import { Component, OnInit, Input, ViewChild, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { BaseComponent } from '../../Library/BaseComponent';
import { ComplainRegister, StaffAssignmentFilter, GuestSearch } from '../../Models/RequestModels';
import { MasterDataService } from '../../Services/MasterDataService';
import { ActivatedRoute, Router } from '@angular/router';
import { CallStatuses, EntityCodes, JobOperationActions } from '../../Models/EnumModels';
import { PMSService } from '../../Services/PMSService';
import { GuestLookup, Staff_Search_Assigment } from '../../Models/ResponseModels';
import * as _ from 'lodash';
import { ComplainService } from '../../Services/ComplainService';
import { CallDescriptionLookup, CallCategoryLookup, LocationLookup } from '../../Models/GlobalEntities';
import { NgbModal, NgbActiveModal, NgbModalRef, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from '../../Services/UserService';
import { JobOperations } from '../JobOperations/JobOperations';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import * as alasql from 'alasql';

@Component({
    selector: 'GuestSearchPopup',
    templateUrl: './GuestSearchPopup.html',
    encapsulation: ViewEncapsulation.None,
    styles: [`
    .popup-left  .modal-dialog {
        margin: 5.75rem 0 1.75rem 4rem;
    }
  `]
})

export class GuestSearchPopup extends BaseComponent implements OnInit {
    @ViewChild('content') content;
    PropertyId: number;

    SelectedId: number;

    RequestModel: GuestSearch;
    Model: Array<GuestLookup> = null;
    disableCloseOnSelect: boolean = false;
    Keyword: string = "";
    ModalRef: NgbModalRef;
    guestlst: Array<GuestLookup> = [];
    allGuestlst: Array<GuestLookup> = [];
    IsLoaded: boolean = false;

    @Output() SelectionChanged: EventEmitter<GuestLookup> = new EventEmitter<GuestLookup>();

    constructor(public translate: TranslateService, public toastr: ToastrService, public route: ActivatedRoute, public router: Router, public masterService: MasterDataService, protected pmsService: PMSService, private modalService: NgbModal) {
        super(translate, toastr, route, router, masterService);

        this.RequestModel = new GuestSearch();
    }

    ngOnInit(): void {

    }

    Open(PropertyId: number, disableClosedOnSelect: boolean = false): void {
        this.RequestModel = new GuestSearch();
        this.RequestModel.PropertyId = PropertyId;
        this.RequestModel.ReservationStatus = 3;
        this.Model = null;
        this.IsLoaded = false;
        this.disableCloseOnSelect = disableClosedOnSelect;

        let allGuest = this.pmsService.GetGuestLookup(this.RequestModel.PropertyId);
        if (disableClosedOnSelect) {
            this.allGuestlst = [];
        } else {
            this.guestlst = allGuest.filter(a => a.ReservationStatus == this.RequestModel.ReservationStatus);
            this.allGuestlst = this.guestlst;
        }
        this.pmsService.SortGuestLook(this.guestlst);
        if (this.guestlst.length > 0) {
            this.IsLoaded = true;
            this.getGuestDataOfCurrentPage();
        }
        let ngbModalOptions: NgbModalOptions;

        if (disableClosedOnSelect) {
            ngbModalOptions = {
                backdrop: 'static',
                size: 'lg',
                centered: false,
                windowClass: 'popup-left'
            };
        } else {
            ngbModalOptions = {
                backdrop: 'static',
                size: 'lg',
                centered: true
            };
        }
        this.ModalRef = this.modalService.open(this.content, ngbModalOptions);
    }

    onSubmit(): void {
        this.Model = null;
        this.SetData();
    }

    onPageChange(): void {
        if (this.IsLoaded) 
            this.getGuestDataOfCurrentPage();
        else 
            this.SetData();
    }

    SetData(): void {
        this.SubmitStart();

        this.pmsService.GuestLookup_Search(this.RequestModel).then(data => {
            this.IsLoaded = false;
            this.Model = data;
            this.SubmitEnd();
        });
    }

    onSelect(row: GuestLookup) : void {
        this.SelectionChanged.emit(row);

        if (!this.disableCloseOnSelect) {
            this.onClose();
        }
    }

    onClose() {
        this.ModalRef.close();
    }
    
    getGuestDataOfCurrentPage(): void {
        let skipRecords = this.RequestModel.PageSize * (this.RequestModel.PageNumber - 1);
        let queryWhere = ' Offset ' + skipRecords + ' Rows Fetch Next ' + this.RequestModel.PageSize + ' Rows Only';
        this.Model = alasql('Select * from ? ' + queryWhere, [this.guestlst]);      
    }
    searchGuestOnKey(): void {
        this.RequestModel.PageNumber = 1;
        if (this.RequestModel.Keyword != null && this.RequestModel.Keyword.trim() != "") {
            let keyword = '%' + this.RequestModel.Keyword.toLocaleUpperCase() + '%';
            this.guestlst = alasql('Select * from ? where UCASE(FullName) like ?', [this.allGuestlst, keyword]);
            this.getGuestDataOfCurrentPage();
        }
        else {
            this.guestlst = this.allGuestlst;
            this.getGuestDataOfCurrentPage();
        }
    }

    loadPreviousData(): void {
        this.IsLoaded = true;
        this.searchGuestOnKey();
    }
}
